import React, { useState } from 'react';
import { submitContactForm } from '../../services/api';
import './CCPAForm.scss';

const CCPAForm = ({ onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    address: '',
    phone: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      await submitContactForm({
        ...formData,
        subject: 'CCPA/CPRA Do Not Sell Request',
        message: 'This is a CCPA/CPRA request to opt out of the sale of personal information.',
        type: 'ccpa_request',
      });
      setSubmitStatus('success');
      setFormData({
        name: '',
        email: '',
        address: '',
        phone: '',
      });
      setTimeout(() => {
        onClose();
      }, 3000);
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="ccpa-form-overlay">
      <div className="ccpa-form-container">
        <button className="close-button" onClick={onClose}>
          &times;
        </button>
        <h2>Do Not Sell My Personal Information</h2>
        <p>
          Submit this form to request that we do not sell your personal information, as per
          CCPA/CPRA requirements.
        </p>

        <form className="ccpa-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Full Name *</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="Your full name"
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email *</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="Your email address"
            />
          </div>

          <div className="form-group">
            <label htmlFor="address">California Address *</label>
            <input
              type="text"
              id="address"
              name="address"
              value={formData.address}
              onChange={handleChange}
              required
              placeholder="Your California address"
            />
          </div>

          <div className="form-group">
            <label htmlFor="phone">Phone Number</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="Your phone number (optional)"
            />
          </div>

          <button type="submit" className="btn btn--primary" disabled={isSubmitting}>
            {isSubmitting ? 'Submitting...' : 'Submit Request'}
          </button>

          {submitStatus === 'success' && (
            <div className="submit-status success">
              Your request has been submitted successfully. We will process it within 45 days.
            </div>
          )}

          {submitStatus === 'error' && (
            <div className="submit-status error">
              Sorry, there was an error submitting your request. Please try again later.
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default CCPAForm;
